import React from 'react';
import {useLocation} from "react-router-dom";
import { Container, Row, Col} from "react-bootstrap";
import {useUser} from "../../UserContext";
const Receipt = () => {
    const location = useLocation();
    const {cart, discount, selectedCustomer, total, paymentMethod, amountPaid, changeToGive,
        vatAmount, preTaxSubtotal, created_at} = location.state;
    const { user } = useUser();
    const getLineSubtotal = (item) => Number(item.line_subtotal ?? (item.quantity * item.price)) || 0;
    const getLineDiscount = (item) => Number(item.quantity_discount ?? 0) || 0;
    const getDiscountedLineSubtotal = (item) => Number(item.discounted_subtotal ?? Math.max(0, getLineSubtotal(item) - getLineDiscount(item))) || 0;
    const quantityDiscountTotal = cart.reduce((sum, item) => sum + getLineDiscount(item), 0);

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6}>
                    <div className="text-center mb-4">
                        <h2>BEEQASI WHOLESALE & RETAIL</h2>
                        <h3>Receipt</h3>
                        <p>Date: {created_at}</p>
                        <p>Phone: 0789525313</p>
                        <p>Mail: beeqasimails@gmail.com</p>
                        <p>Location: Ngong Town, Kajiado</p>
                        <p>Served by: {user.username}</p>
                    </div>
                    <hr/>
                    <div>
                        <Row className="mb-2">
                            <Col xs={6}><strong>Item</strong></Col>
                            <Col xs={3} className="text-right"><strong>Qty</strong></Col>
                            <Col xs={3}><strong>Price</strong></Col>
                        </Row>
                        {cart.map((item, index) => (
                            <React.Fragment key={index}>
                                <Row className="mb-2">
                                    <Col xs={6}>
                                        {item.name}
                                        {/*{item.isAlternativeUnit ? ` ${item.unit_name || item.unit_abbreviation || 'Unit'}` : ''}*/}
                                        {/*check if unit_id of alternative unit exists*/}
                                        {item.unit_id && item.unit_name ? ` ${item.unit_name}` : ""}
                                    </Col>
                                    <Col xs={3} className="text-right">{item.quantity} x</Col>
                                    <Col xs={3}>Ksh. {parseFloat(item.price).toFixed(2)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs={9}></Col>
                                    <Col xs={3}>Ksh. {getDiscountedLineSubtotal(item).toFixed(2)}</Col>
                                </Row>
                                {getLineDiscount(item) > 0 && (
                                    <Row className="mb-2 text-success">
                                        <Col xs={9}>{item.quantity_discount_reason || 'Quantity discount'}</Col>
                                        <Col xs={3}>- Ksh. {getLineDiscount(item).toFixed(2)}</Col>
                                    </Row>
                                )}
                                <hr/>
                            </React.Fragment>
                        ))}
                        <Row className="mb-2">
                            <Col xs={9}>Subtotal (pre VAT): </Col>
                            <Col xs={3}><strong>Ksh. {preTaxSubtotal.toFixed(2)}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>VAT 16%: </Col>
                            <Col xs={3}><strong>Ksh. {vatAmount.toFixed(2)}</strong></Col>
                        </Row>
                        {discount > 0 && (
                            <Row className="mb-2">
                                <Col xs={9}>Discount: </Col>
                                <Col xs={3}>- Ksh. {discount.toFixed(2)}</Col>
                            </Row>
                        )}
                        {quantityDiscountTotal > 0 && (
                            <Row className="mb-2 text-success">
                                <Col xs={9}>Quantity Discount: </Col>
                                <Col xs={3}>- Ksh. {quantityDiscountTotal.toFixed(2)}</Col>
                            </Row>
                        )}
                        <Row className="mb-2">
                            <Col xs={9}>Total: </Col>
                            <Col xs={3}><strong>Ksh. {total.toFixed(2)}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Payment Method: </Col>
                            <Col xs={3}>{paymentMethod}</Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Amount Paid: </Col>
                            <Col xs={3}><strong>Ksh. {amountPaid}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Change: </Col>
                            <Col xs={3}><strong>Ksh. {changeToGive.toFixed(2)}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Customer: </Col>
                            <Col xs={3}>{selectedCustomer.name || 'Walk-in'}</Col>
                        </Row>
                    </div>
                    <div className="text-center mb-4">
                        <h2>Buy Goods Till No; 4030382</h2>
                        <p>Thank you for shopping with us!</p>
                    </div>
                    <hr/>
                    {/*<div className="text-center mt-4">*/}
                    {/*    <Button variant="success" onClick={() => window.print()}>Print Receipt</Button>*/}
                    {/*</div>*/}
                </Col>
            </Row>
        </Container>
    );
};

export default Receipt;